// eslint-disable-next-line no-shadow
enum ENaturezaJuridica {
  LTDA = 'LTDA',
  SA = 'SA',
  FundoDeInvestimento = 'FundoDeInvestimento',
  MEI = 'MEI',
}

export default ENaturezaJuridica
